import React from "react";
import HumanBanner from "../humanresources/HumanBanner";
import SmallBusinessPlace from "./SmallBusinessPlace";
import SmallBusinessBuilt from "./SmallBusinessBuilt";
import SmallBusinessGallery from "./SmallBusinessGallery";
import SmallMidSized from "./SmallMidSized";
import SmallWorkforce from "./SmallWorkforce";
import SmallLaunch from "./SmallLaunch";
import SmallBoost from "./SmallBoost";
import HumanCompany from "../humanresources/HumanCompany";

const bannerData = {
  head: "Smart Document Management for Growing Businesses",
  desc: "Move beyond paper files and scattered systems. Dox and Box helps small and mid-sized businesses take complete control of their documents and workflows with secure, cloud-based solutions, eliminating inefficiencies and simplifying everyday operations.",
  slug: "",
  btn: "Contact Us",
  img: "/assets/images/small-business-banner.webp"
}

const placeData = {
  head: "More Than Storage, A Smarter Way to Work",
  desc: "Dox and Box combines powerful document management with intelligent workflow automation to help SMBs operate more efficiently. Capture, organize, access your business information in one centralized platform, while replacing manual processes with fast, digital workflows, all through an intuitive, easy-to-use interface."
}

const galleryData = [
  {
    head: "Organize and Secure Your Documents",
    list: [
      "Easily upload and manage files while automatically extracting and organizing key data.",
      "Store documents in a secure environment with advanced encryption and role-based access controls, ensuring your business information is always protected and easy to find."
    ],
    img: "/assets/images/small-business-gallery-img-1.webp",
    label: "DocuWare document organization and security on mobile device | small business document management"
  },
  {
    head: "Automate Workflows and Everyday Tasks",
    list: [
      "Streamline routine processes with automated workflows tailored to your business needs. Assign tasks, send notifications, enable quick approvals, reducing manual effort and improving overall efficiency."
    ],
    img: "/assets/images/small-business-gallery-img-2.webp",
    label: "Automate workflows (left) and assign users tasks (right)"
  },
  {
    head: "Stay Connected, Work from Anywhere",
    list: [
      "Empower your team to access, share, collaborate on documents from a centralized system, whether they’re in the office, working remotely, or on the go. With secure, anytime access across devices, your business stays productive no matter where work happens."
    ],
    img: "/assets/images/small-business-gallery-img-3.webp",
    label: "Connect mobile and remote workers with simple document management and workflow"
  },
]

const builtData = {
  head: "Built for Growing Businesses",
  desc: "Dox and Box is designed to support the evolving needs of small and mid-sized businesses. Powered by a modern, cloud-first infrastructure, our platform delivers the scalability, security, flexibility you need.",
  boxes: [
    {
      img: "/assets/images/smart-built-icon1.webp",
      title: "User-Friendly",
      desc: "Get started quickly with an intuitive interface built for everyday business users, no steep learning curve required.",
    },
    {
      img: "/assets/images/smart-built-icon2.webp",
      title: "Cloud-Based Access",
      desc: "Access your documents anytime, from any device, through a secure browser-based platform.",
    },
    {
      img: "/assets/images/smart-built-icon3.webp",
      title: "Mobile-Ready",
      desc: "Capture, store, retrieve documents using your device, perfect for teams working remotely or in the field.",
    },
    {
      img: "/assets/images/smart-built-icon4.webp",
      title: "Advanced Security",
      desc: "Protect your business data with encryption, role-based access controls, reliable backup systems.",
    },
  ]
}

const midData = {
  head: "Designed for Real Business Workflows",
  desc: "Dox and Box supports the core, document-driven processes that power your business, helping you improve speed, accuracy, control across operations. Whether you're managing a small team or scaling rapidly, our solutions adapt to your needs.",
 
}

const workforceData = {
  head: "Put a remote workforce in place with a secure, easy-to-implement cloud document management solution",
  desc: "Discover how easily your team can implement a modern, cloud-based document management solution to digitize your paper documents and let your remote employees easily access information when they need it.",
  img: "/assets/images/small-workforce-image.webp",
  btn: "Watch the webinar",
  slug: "",
}

const launchData = {
  head: "Get Started Faster with Ready-to-Deploy Solutions",
  desc: "Accelerate your digital transformation with pre-configured solutions designed for quick implementation and immediate impact. With built-in workflows, templates, user structures, you can streamline operations and start seeing results in no time.",
  boxes: [
    {
      img: "/assets/images/small-launch-img-1.webp",
      title: "Invoice processing",
      desc: "Digitize invoices with intelligent indexing for secure storage and instant retrieval. Automate approval workflows to speed up payments and improve financial efficiency.",
      label: "Eliminate paperwork and manual entry",
      btnText: "Know More",
      slug: ""
    },
    {
      img: "/assets/images/small-launch-img-2.webp",
      title: "Employee Record Management",
      desc: "Centralize and secure employee records, eliminating scattered files and shared drives. Access critical information instantly while maintaining compliance and data security.",
      label: "All employee data in one place",
      btnText: "Know More",
      slug: ""
    },
  ]
}

const boostData = {
  heading: "Optimize Financial Operations with Workflow Automation",
  description: "Accounts payable and other finance processes are often burdened by manual, repetitive tasks. Dox and Box helps enterprises automate key workflows, such as invoice processing and approvals, improving efficiency, reducing errors, boosting team productivity.",
  btn: "Read More",
  slug: "",
}

export default function SmallBusiness({ initialData }) {
  return (
    <>
      <HumanBanner data={bannerData} />
      <SmallBusinessPlace data={placeData} />
      <SmallBusinessGallery data={galleryData} />
      <SmallBusinessBuilt data={builtData} />
      <SmallMidSized data={midData} initialData={initialData} />
      <SmallWorkforce data={workforceData} />
      <SmallLaunch data={launchData} />
      <SmallBoost data={boostData} />
      <HumanCompany />
    </>
  )
}